const $$splitComponentImporter = () => import('/src/src/routes/_authenticated/_feature_announcement/_user/profile/edit/outlook.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { createFileRoute } from "@tanstack/react-router";
import { defineMessage } from "react-intl";
export const Route = createFileRoute("/_authenticated/_feature_announcement/_user/profile/edit/outlook")({
  component: lazyRouteComponent($$splitComponentImporter, 'component'),
  staticData: {
    pageTitle: defineMessage({
      defaultMessage: "Outlook",
      description: "Page title for the outlook path"
    })
  }
});